import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { GlitterHeart } from './GlitterHeart';
export function Footer() {
  return <footer className="bg-white border-t border-blush-100 pt-16 pb-8 relative overflow-hidden" data-id="element-18">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-blush-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-float" data-id="element-19" />
      <div className="absolute top-0 right-1/4 w-64 h-64 bg-lavender-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-20" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-22">
          <div className="col-span-1 md:col-span-2" data-id="element-23">
            <Link to="/" className="flex items-center gap-2 mb-4 group" data-id="element-24">
              <GlitterHeart size={22} className="group-hover:scale-125 transition-transform" data-id="element-25" />
              <span className="font-heading text-2xl font-semibold text-plum-700" data-id="element-26">
                Trippin' With Mandy™
              </span>
            </Link>
            <p className="text-plum-500 max-w-sm mb-6 leading-relaxed" data-id="element-27">
              Rebuilding the world one soul at a time. The Broken Beginning —
              and taking you with me.
            </p>
            <div className="flex gap-4" data-id="element-28">
              <a href="#" className="p-2 bg-blush-50 rounded-full text-plum-500 hover:text-cta-500 hover:bg-blush-100 transition-colors" aria-label="Instagram" data-id="element-29">
                <InstagramIcon className="w-5 h-5" data-id="element-30" />
              </a>
              <a href="#" className="p-2 bg-blush-50 rounded-full text-plum-500 hover:text-cta-500 hover:bg-blush-100 transition-colors" aria-label="TikTok" data-id="element-31">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-32">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-33" />
                </svg>
              </a>
              <a href="#" className="p-2 bg-blush-50 rounded-full text-plum-500 hover:text-cta-500 hover:bg-blush-100 transition-colors" aria-label="Email" data-id="element-34">
                <MailIcon className="w-5 h-5" data-id="element-35" />
              </a>
            </div>
          </div>

          <div data-id="element-36">
            <h3 className="font-heading font-semibold text-lg text-plum-700 mb-4" data-id="element-37">
              Explore
            </h3>
            <ul className="space-y-3" data-id="element-38">
              <li data-id="element-39">
                <Link to="/" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-40">
                  Home
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/about" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-42">
                  About Mandy
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/courses" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-44">
                  Courses
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/coaching" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-46">
                  1:1 Coaching
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/travel" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-48">
                  Travel Planning
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-49">
            <h3 className="font-heading font-semibold text-lg text-plum-700 mb-4" data-id="element-50">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-51">
              <li data-id="element-52">
                <Link to="/app" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-53">
                  The App (Coming Soon)
                </Link>
              </li>
              <li data-id="element-54">
                <a href="#" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-55">
                  Free Resources
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-57">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-blush-100 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-58">
          <p className="text-sm text-plum-500" data-id="element-59">
            © {new Date().getFullYear()} Trippin' With Mandy™. All rights
            reserved.
          </p>
          <p className="text-sm text-plum-500 flex items-center gap-1" data-id="element-60">
            Made with <GlitterHeart size={16} data-id="element-61" /> and a whole lot of grit
          </p>
        </div>
      </div>
    </footer>;
}